// URL/key generators for stadium names. Single source of truth — every page
// that builds a /stadiums/{country}/{slug} URL must import from here so the
// link target matches the route-matcher's reverse lookup.
//
// Two transformations:
//   slugify(name)  → "estadio-santiago-bernabeu"   (URL slug, hyphens)
//   keyify(name)   → "estadio_santiago_bernabeu"   (data-file key, underscores)
//
// Both transliterate diacritics (NFD + strip combining marks) and drop
// apostrophes/ampersands cleanly so "Levi's Stadium" → "levis-stadium" and
// "AT&T Stadium" → "att-stadium" match the keys used in fan_favourites.json,
// stadium_images.json, and the per-stadium guides/.
//
// Authored as CommonJS (module.exports) so the build scripts
// (generate-sitemap.js, generate-llms.js, prerender-meta.js) can require()
// this exact module, while the CRA runtime imports it via webpack's CJS/ESM
// interop. ONE source of truth — the hand-synced copies are gone.

const transliterate = (name) =>
  name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[‘’']/g, '')
    .replace(/&/g, '');

const slugify = (name) =>
  transliterate(name)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

const keyify = (name) =>
  transliterate(name)
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/(^_|_$)/g, '');

// Country URL-param → data-key normaliser. Country keys in the data files use
// underscores (united_states_of_america); a /stadiums/:countryName param may
// arrive underscored (directory links emit the raw key) or hyphenated (Search
// builds /stadiums/united-states-of-america). Collapse any run of spaces or
// hyphens to a single underscore so both forms resolve to the one data key.
// Single source of truth — pages must not re-roll this inline.
const getCountryKey = (s) => (s || '').toLowerCase().replace(/[\s-]+/g, '_');

module.exports = { slugify, keyify, getCountryKey };
